import { render, staticRenderFns } from "./TemplateConfig.vue?vue&type=template&id=52f26707&scoped=true"
import script from "./TemplateConfig.vue?vue&type=script&lang=js"
export * from "./TemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./TemplateConfig.vue?vue&type=style&index=0&id=52f26707&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f26707",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f26707')) {
      api.createRecord('52f26707', component.options)
    } else {
      api.reload('52f26707', component.options)
    }
    module.hot.accept("./TemplateConfig.vue?vue&type=template&id=52f26707&scoped=true", function () {
      api.rerender('52f26707', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/TemplateConfig.vue"
export default component.exports